const WHATSAPP_NUMBER = "33626203846";
const WHATSAPP_BASE_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

const buildPageContextMessage = (pageUrl = window.location.href) =>
  `${pageUrl}`;

export const buildWhatsAppUrlWithPageLink = (pageUrl = window.location.href) => {
  const encodedMessage = encodeURIComponent(buildPageContextMessage(pageUrl));
  return `${WHATSAPP_BASE_URL}?text=${encodedMessage}`;
};

export const openWhatsAppWithPageLink = (pageUrl = window.location.href) => {
  window.open(buildWhatsAppUrlWithPageLink(pageUrl), "_blank", "noopener,noreferrer");
};

export const attachWhatsAppPageContext = (root = document) => {
  const links = root.querySelectorAll(`a[href^="${WHATSAPP_BASE_URL}"]`);
  const urlWithContext = buildWhatsAppUrlWithPageLink();

  links.forEach((link) => {
    link.setAttribute("href", urlWithContext);
    const rel = link.getAttribute("rel") || "";

    if (!rel.includes("noopener")) {
      link.setAttribute("rel", `${rel} noopener noreferrer`.trim());
    }
  });
};
